











import Vue from 'vue';

import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import FilterSection from '@/components/filter/FilterSection.vue';
import MultipleSelectMixin from '@/mixins/MultipleSelectMixin.vue';
import MultipleSelect from '../shared/MultipleSelect.vue';

@Component({
  mixins: [MultipleSelectMixin],
  components: {
    FilterSection,
    MultipleSelect,
  },
})
export default class DocumentsTypeFilter extends Vue {
  @Getter('getTypeOptions', { namespace: 'incorporatedDocument' })
  private options!: string[];

  @Getter('getSelectedType', { namespace: 'incorporatedDocument' })
  private selected!: string[];

  public toggleCheckbox(options): void {
    this.$emit('on-type-change', options);
  }
}
